'use client';

import React, { type ReactNode } from 'react';
import styled from 'styled-components';
import { useInView } from 'react-intersection-observer';
import { useStickyNav } from './StickyNavContext';

const Wrapper = styled.div<{ $isSticky: boolean; $hasShadow: boolean; $top: number }>`
  position: ${({ $isSticky }) => ($isSticky ? 'sticky' : 'static')};
  top: ${({ $top }) => $top}px;
  z-index: 10;
  box-shadow: ${({ $hasShadow }) => ($hasShadow ? ({ theme }) => theme?.kallisto?.shadow?.mediumDownShadow : 'none')};
  transition: top 0.35s ease-out;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

const StickyNavFilters = ({ children, topOffset }: { children: ReactNode; topOffset: number }) => {
  const { isOut, scrollDirection, setIsOut } = useStickyNav();
  const { ref: sentinelRef } = useInView({ threshold: 0, onChange: (inView) => setIsOut(!inView) });

  return (
    <>
      <div ref={sentinelRef} style={{ height: 0, width: 0 }} />
      {/* Scrolling up, the filters stay below the revealed header until they reach their own place in
          the page, instead of dropping behind it as soon as that place scrolls back into view. Scrolling
          down near the top they stay sticky, so `top` slides them back in step with the header. */}
      <Wrapper
        $isSticky={isOut || scrollDirection !== null}
        $hasShadow={isOut || scrollDirection === 'up'}
        $top={scrollDirection === 'up' ? topOffset : 0}
      >
        {children}
      </Wrapper>
    </>
  );
};

export default StickyNavFilters;
